import React, { Component } from 'react';

import './style/openCheckbox.scss';

export default class OpenCheckbox extends Component {
	state = {
		values: [],
		openOption: '',
		checkable: true,
		disabled: false,
		showAll: false,
	};

	componentDidMount() {
		const { valueField } = this.props;
		if (valueField) {
			this.setState({
				openOption: valueField.openOption,
				values: valueField.values,
			});
		}
	}

	updateValues() {
		const { values, openOption } = this.state;
		const { nameField, onChange } = this.props;

		const e = {
			target: {
				name: nameField,
				value: {
					values,
					openOption,
				},
			},
		};

		onChange(e);
	}

	handleCheckClick(e) {
		let { values, openOption } = this.state;
		const { maxInput } = this.props;

		const element = e.target;

		if (element.checked) {
			values = element.value;
			openOption = '';
			const prevState = this.state;
			this.setState({ ...prevState, openOption });
		}

		this.setState({
			values,
			openOption,
			disabled: values.length >= maxInput,
		}, this.updateValues);
	}

	handleOpenOption(e) {
		let { values } = this.state;
		if (!values.includes('open') && e.target.value.length > 0) {
			values = 'open';
		}

		const { prevState } = this.state;
		this.setState({
			...prevState,
			values,
			openOption: e.target.value,
		}, this.updateValues);
	}

	seeMore() {
		return this.setState({
			showAll: true,
		});
	}

	renderOptions() {
		const {
			options,
			nameField,
			valueField,
			label,
			meta,
		} = this.props;

		let parentValues = [];

		if (typeof valueField.values !== 'undefined') {
			parentValues = valueField.values;
		} else if (valueField.length > 0 && typeof valueField === 'string') {
			parentValues = JSON.parse(valueField).values;
		}
		return options.map((option, index) => {
			const {
				openOption,
			} = this.state;
			const fieldKey = `${option.value}_${index}`;

			if (option.editable) {
				return (
					<div className="form-check w-100" key={fieldKey}>
						<label
							className="form-check-label container-option-field-text"
							htmlFor={nameField + option.value}
						>
							<input
								className="form-check-input css-radio"
								type="radio"
								value="open"
								id={nameField + option.value}
								name="open"
								onChange={this.handleCheckClick.bind(this)}
								checked={parentValues.includes('open')}
							/>
							<i />
							<input
								className="field-text"
								type="text"
								value={openOption}
								onChange={this.handleOpenOption.bind(this)}
								placeholder={option.label}
							/>
						</label>
					</div>
				);
			}

			if (meta.alias === 'modelos_carros') {
				const { showAll } = this.state;

				return (
					<div
						className={`form-check ${(index < 10 || showAll) ? 'd-block' : 'd-none'}`}
						key={fieldKey}
					>
						<label
							className="form-check-label"
							htmlFor={nameField + option.value}
						>
							{
								(typeof option.image !== 'undefined')
									? (
										<div className="checkbox-image">
											<img src={option.image} alt={label} />
										</div>
									)
									: ''
							}

							<div className="container-options">
								<input
									className="form-check-input css-radio"
									type="radio"
									value={option.value}
									id={nameField + option.value}
									name={nameField}
									onChange={this.handleCheckClick.bind(this)}
									checked={(parentValues.includes(option.value))}
								/>
								<i />
								{option.label}
							</div>
						</label>
					</div>
				);
			}

			return (
				<div className="form-check" key={option.value}>
					<label className="form-check-label" htmlFor={nameField + option.value}>
						<input
							className="form-check-input css-radio"
							type="radio"
							value={option.value}
							id={nameField + option.value}
							name={nameField}
							onChange={this.handleCheckClick.bind(this)}
							checked={(parentValues.includes(option.value))}
						/>
						<i />
						{option.label}
						{
							(typeof option.image !== 'undefined')
								? (
									<div className="checkbox-image">
										<img src={option.image} alt={label} />
									</div>
								)
								: ''
						}
					</label>
				</div>
			);
		});
	}

	render() {
		const { meta, nameField } = this.props;

		return (
			<div key={nameField} className={(meta.alias === 'modelos_carros') ? 'container_cars' : ''}>
				{ this.renderOptions() }

				{(meta.alias === 'modelos_carros')
					? (
						<button
							type="button"
							className="w-100 btn-see-more"
							onClick={this.seeMore.bind(this)}
						>
							VER MAIS OPÇÕES
						</button>
					)
					: ''}
			</div>
		);
	}
}
